import { toast } from "react-toastify";
import config from '../../Config/config.json';
import { LogOut, changeLoations } from "../../Redux/Actions/index.js";
import { store } from "../../Redux/Store/index.js";
import { EquipamentRequests } from "./request.ts";
import i18n from "../../Config/i18n.js";
import mapboxgl from "mapbox-gl";
import { MapMarkerGreen, ReservatorioGreen, VazaoGreen, LevelGreen, PressureGreen, 
    PocoGreen, ETAGreen, GeneralIconGreen } from "../../Assets/icons/MapIcons";

/**
 * Classe para gerenciamento da página de equipamentos
 */
export class EquipamentServices {
    constructor() {
        this.equipamentRequests = new EquipamentRequests();
        this.accessToken = 'pk.eyJ1IjoiYXVnZW5lbmdlbmhhcmlhIiwiYSI6ImNsZjJndWZ6YjBieHIzcnFwMTE3ZnZhMDUifQ.vXY4O2xgCvVyVA9BtI79mQ';
        this.style = 'mapbox://styles/augenengenharia/clf2kkzoh000901w34rdkrck6';
    }
    
    // Busca dados do equipamento
    async getEquipament(id){
        try {
            const response = await this.equipamentRequests.getEquipamento(id);
            return response.data;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    // Envia o usuário para ser editado
    async editEquipament (Id, equipamento){
        try {
            const response = await this.equipamentRequests.editEquipament(Id, equipamento);
            toast(i18n.t("message.equipament-service.response-edit-equipment"), {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    // Busca todos equipamentos
    async getAllEquipaments(search, page){
        try {
            const response = await this.equipamentRequests.getAllEquipaments(search, page);
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return [];
        }
    }

    // Cria um novo equipamento
    async Saveequipament (equipamento){
        try {
            const response = await this.equipamentRequests.CreateEquipament(equipamento);
            toast(i18n.t("message.equipament-service.response-save-equipment"), {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    // Busca alocações que o usuário pode ver
    async getLocations(){
        try {
            const response = await this.equipamentRequests.getlocations();
            this.locations = response;
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    // Muda o tipo de alocações sendo exibido
    ChangeLocationType(type){
        store.dispatch(changeLoations(this.locations[type]));
    }

    // Busca estados
    async getStates(){
        try {
            const response = await this.equipamentRequests.getStates();
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return [];
        }
    }

    // Busca cidades
    async getCities(state){
        try {
            const response = await this.equipamentRequests.getCities(state);
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return [];
        }
    }

    async deleteEquipament(id, navigate){
        try {
            const response = await this.equipamentRequests.deleteEquipament(id);
            toast(response.message, {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            navigate('/adm/equipamentos');
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
        }
    }

    async refreshAllEquipments() {
        try {
            const response = await this.equipamentRequests.refreshAllEquipaments();
            toast(response.message, {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
        }
    }

    async refreshEquipment(id) {
        try {
            const response = await this.equipamentRequests.refreshEquipament(id);
            toast(response.message, {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
        }
    }

    // adiciona as imagens ao mapa
    async addImages(){
        // Imagens de equipamentos
        try {
            let MapMarkerGreenImage = new Image(108, 44);
            MapMarkerGreenImage.src = MapMarkerGreen;
            MapMarkerGreenImage.onload = ()=> this.map.addImage('MapMarker', MapMarkerGreenImage);

            let ReservatorioGreenImage = new Image(42, 50);
            ReservatorioGreenImage.src = ReservatorioGreen;
            ReservatorioGreenImage.onload = ()=> this.map.addImage('Reservatorio', ReservatorioGreenImage);

            let VazaoGreenImage = new Image(50, 28);
            VazaoGreenImage.src = VazaoGreen;
            VazaoGreenImage.onload = ()=> this.map.addImage('Vazao', VazaoGreenImage);

            let LevelGreenImage = new Image(28, 50);
            LevelGreenImage.src = LevelGreen;
            LevelGreenImage.onload = ()=> this.map.addImage('Level', LevelGreenImage);

            let PressureGreenImage = new Image(53, 40);
            PressureGreenImage.src = PressureGreen;
            PressureGreenImage.onload = ()=> this.map.addImage('Pressure', PressureGreenImage);

            let PocoGreenImage = new Image(55, 80);
            PocoGreenImage.src = PocoGreen;
            PocoGreenImage.onload = ()=> this.map.addImage('PocoGreen', PocoGreenImage);

            let ETAGreenImage = new Image(150, 75);
            ETAGreenImage.src = ETAGreen;
            ETAGreenImage.onload = ()=> this.map.addImage('ETA', ETAGreenImage);

            let GeneralIconGreenImage = new Image(45, 45);
            GeneralIconGreenImage.onload = ()=> this.map.addImage('General', GeneralIconGreenImage);
            GeneralIconGreenImage.src = GeneralIconGreen;

        } catch (error) {
            console.log(error+'Ao carregar as imagens dos equipamentos')
        }
    }

    // Inicia o mapa com as coordenadas do equipamento
    async startMap(mapContainer, latitude, longitude, id, name, type) {
        mapboxgl.accessToken = this.accessToken;
        this.map = new mapboxgl.Map({
            container: mapContainer,
            style: this.style,
            center: [longitude, latitude],
            pitch: 50,
            bearing: 0,
            zoom: 12.5,
            minZoom: 2.5,
        });
        this.currentArea = [];
        this.currentLine = [];
        this.history = [{
            location:{
                lat: latitude,
                lng: longitude
            },
            area: [],
            line: [],
        }];
        this.redoHistory = [];

        this.type = 'location';
        this.id = id;
        this.name = name;
        this.icontype = type;

        await this.addImages();
        this.map.on('load', () => {
            this.loadEquipment(latitude, longitude, id, name, type);
            this.loadMapEvents();
        });
    }

    // Redimensiona o mapa
    resizeMap() {
        setTimeout(() => {
            if (this.map) {
                this.map.resize();
            }
        }, 1);
    }

    // set change type
    setClickType(type) {
        this.type = type;
    }

    // carrega os eventos do mapa
    loadMapEvents() {
        try {
            this.map.on('click', (e) => {
                if(this.type === 'area'){
                    if(this.currentArea.length > 0){this.history.push({area: JSON.parse(JSON.stringify(this.currentArea))});}
                    this.currentArea.push([e.lngLat.lng, e.lngLat.lat])
                    if(this.currentArea.length > 1) {
                        this.loadAreas();
                    }
                }else if(this.type === 'line'){
                    if(this.currentLine.length > 0){this.history.push({line: JSON.parse(JSON.stringify(this.currentLine))});}
                    this.currentLine.push([e.lngLat.lng, e.lngLat.lat])
                    if(this.currentLine.length > 1) {
                        this.loadLines();
                    }
                }else if(this.type === 'location'){
                    if(this.newCoords){this.history.push({location: this.newCoords});
                    }else{this.history.push({location: this.history[0].location})}
                    this.updateEquipmentLocation(e.lngLat.lat, e.lngLat.lng);
                }
            })
        } catch (error) {
            console.log(error)
        }
    }

    // adiciona o equipamento no mapa
    loadEquipment(lat, lng, id, name, type) {
        this.map.addSource('points', {
            'type': 'geojson',
            'data': {
                'type': 'FeatureCollection',
                'features': [
                    {
                        'type': 'Feature',
                        'geometry': {
                            'type': 'Point',
                            'coordinates': [lng, lat]
                        },
                        'properties': {
                            'id': id,
                            'icon': type,
                            'name': name
                        }
                    }
                ]
            },
            'cluster': false,
        });

        this.map.addLayer({
            id: 'unclustered-equipamentos',
            type: 'symbol',
            source: 'points',
            layout: {
                "icon-image":  [
                    'case',
                    ['==', ['get', 'icon'], '52e63208-66ed-4a57-b41f-6f93b1b12f76'], 'MapMarker',
                    ['==', ['get', 'icon'], '8831aa23-aa96-468f-bd48-10463cdaea6b'], 'Reservatorio',
                    ['==', ['get', 'icon'], 'de4a6821-eb4c-492b-96c1-7ab704f053f6'], 'Reservatorio',
                    ['==', ['get', 'icon'], '782e9b76-5a92-4ad4-ba2a-5a6f84cb9ae1'], 'Vazao',
                    ['==', ['get', 'icon'], 'd0effc9e-4b90-4212-b800-4fb17cd5f67a'], 'Vazao',
                    ['==', ['get', 'icon'], 'ce27f1ab-2a42-45a2-a5c1-2a4e498b90d6'], 'Level',
                    // TODO
                    ['==', ['get', 'icon'], 'pressao'], 'Pressure',
                    ['==', ['get', 'icon'], 'poco'], 'Poco',
                    ['==', ['get', 'icon'], 'e2a17428-badd-4b2a-ace9-7f428f78cc1f'], 'ETA',
                    'General'
                ],
                'icon-size': 1,
                'icon-allow-overlap': true,
            },
        });

        this.map.addLayer({
            id: 'Text-Blue',
            type: 'symbol',
            source: 'points',
            layout: {
                'text-field': ['get', 'name'],
                'text-size': 12,
                'text-anchor': 'center',
                'text-justify': 'center',
                'icon-allow-overlap': true,
                'text-font':  ["Roboto Bold"],
                'text-offset': [
                    "case",
                    ["==", ["get", "icon"], "de4a6821-eb4c-492b-96c1-7ab704f053f6"],
                    ["literal", [0, 2.5]],
                    ["==", ["get", "icon"], "8831aa23-aa96-468f-bd48-10463cdaea6b"],
                    ["literal", [0, 2.5]],
                    ["==", ["get", "icon"], "d0effc9e-4b90-4212-b800-4fb17cd5f67a"],
                    ["literal", [0, 2.3]],
                    ["literal", [0, 3.5]]
                    
                ],

            },
            paint: {
                'text-color': '#333',
            },
        });
        
    }

    // atualiza a localização do equipamento
    async updateEquipmentLocation(lat, lng) {
        try {
            this.map.getSource('points').setData({
                'type': 'FeatureCollection',
                'features': [
                    {
                        'type': 'Feature',
                        'geometry': {
                            'type': 'Point',
                            'coordinates': [lng, lat]
                        },
                        'properties': {
                            'id': this.id,
                            'icon': this.icontype,
                            'name': this.name
                        }
                    }
                ]
            });
            this.newCoords = {
                lat: lat,   
                lng: lng
            };
        } catch (error) {
            console.error("Erro ao atualizar a localização do equipamento:", error);
        }
    }

    async EquipmentHistory(id, datainicio, datafim, action, target_id = undefined){
        try {
            let data1 = this.formatarDataParaYMDHMS(datainicio);
            let data2 = this.formatarDataParaYMDHMS(datafim);
            
            const payload = {
                equipment_id: id,
                startDate: data1,
                endDate: data2,
                action: action
            };

            if (typeof target_id !== 'undefined' && target_id !== null) payload.target_id = target_id;
            
            const response = await this.equipamentRequests.EquipmentHistory(payload);

            toast(response.message, {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            
            });

        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
        }
    }


    // Formatar a data
    formatarDataParaYMDHMS(time) {
        let data = new Date(time);
        const year = data.getFullYear();
        const month = String(data.getMonth() + 1).padStart(2, '0');
        const day = String(data.getDate()).padStart(2, '0');
        const hours = String(data.getHours()).padStart(2, '0');
        const minutes = String(data.getMinutes()).padStart(2, '0');
        const seconds = String(data.getSeconds()).padStart(2, '0');
        
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }

    // Formatar a data
    formatarDataParaDMHM(time) {
        let data = new Date(time);
        const month = String(data.getMonth() + 1).padStart(2, '0');
        const day = String(data.getDate()).padStart(2, '0');
        const hours = String(data.getHours()).padStart(2, '0');
        const minutes = String(data.getMinutes()).padStart(2, '0');
        
        return `${day}-${month} ${hours}h${minutes}m`;
    }

    
    
    // carrega areas para o mapa
    loadAreas() {
        let currentAreas = JSON.parse(JSON.stringify(this.currentArea));
        currentAreas.push(currentAreas[0]);
        let areaFeature = [];
        let LineFeatures = [];
        // Area sendo adicionada
        if(currentAreas.length > 1){
            areaFeature.push({
                'type': 'Feature',
                'properties': {},
                'geometry': {
                    'type': 'Polygon',
                    'properties': {},
                    'coordinates': [currentAreas]
                },
            });
            LineFeatures.push({
                'type': 'Feature',
                'properties': {
                    id: this.id,
                    name: this.name,
                },
                'geometry': {
                    'type': 'LineString',
                    'coordinates': currentAreas
                }
            });
        }
        // Areas salvas
        if(this.areas?.length > 0){
            this.areas.forEach(area => {
                areaFeature.push({
                    'type': 'Feature',
                    'properties': {
                        id: area.id,
                        name: area.name,
                    },
                    'geometry': {
                        'type': 'Polygon',
                        'coordinates': area.area.coordinates
                    }
                });
                LineFeatures.push({
                    'type': 'Feature',
                    'properties': {
                        id: area.id,
                        name: area.name,
                    },
                    'geometry': {
                        'type': 'LineString',
                        'coordinates': area.area.coordinates[0]
                    }
                });
            });
        }
        if(areaFeature.length < 1){
            return
        }
        let newAreas = {
            'type': 'FeatureCollection',
            'features': areaFeature
        };
        this.removeAreas();
        this.map.addSource('Area', {
            'type': 'geojson',
            'data':  newAreas,
            "promoteId": "id"
        });

        this.map.addSource('area-lines',{
            'type': 'geojson',
            'data': {
                type: "FeatureCollection",
                features: LineFeatures
            },
            "promoteId": "id"
        })

        this.map.addLayer({
            'id': 'Area-outline',
            'type': 'line',
            'source': 'area-lines',
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
            },
            'paint': {
                'line-color': 'blue',
                'line-width': 2,
            },
        });

        this.map.addLayer({
            'id': 'Area',
            'type': 'fill',
            'source': 'Area',
            'layout': {},
            'paint': {
                'fill-color': 'blue',
                'fill-opacity': 0.3,
            }
        });
    }

    // carrega linhas para o mapa
    loadLines() {
        this.removeLines();

        this.map.addSource('supply-lines',{
            'type': 'geojson',
            'data': {
                type: "FeatureCollection",
                features: [
                    {
                        type: "Feature",
                        geometry: {
                            type: "LineString",
                            coordinates: this.currentLine
                        },
                        properties: {
                            id: this.id,
                            icon: this.icontype,
                            name: this.name
                        }
                    }
                ]
            },
            "promoteId": "id"
        })

        this.map.addLayer({
            'id': 'supply-lines-layer',
            'type': 'line',
            'source': 'supply-lines',
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
            },
            'paint': {
                'line-color': '#A1AEC9',
                'line-width': 6,
            },
        });
    }

    // Remove as linhas do mapa
    removeLines() {
        try {
            if (this.map.getLayer('supply-lines-layer')) {
                this.map.removeLayer('supply-lines-layer');
            }
            if (this.map.getSource('supply-lines')) {
                this.map.removeSource('supply-lines');
            }
        } catch (error) {
            console.error("Erro ao remover linhas:", error);
        }
    }

    // Remove as areas do mapa
    removeAreas() {
        try {
            if (this.map.getLayer('Area')) {
                this.map.removeLayer('Area');
            }
            if (this.map.getLayer('Area-outline')) {
                this.map.removeLayer('Area-outline');
            }
            if (this.map.getSource('Area')) {
                this.map.removeSource('Area');
            }
            if (this.map.getSource('area-lines')) {
                this.map.removeSource('area-lines');
            }
        } catch (error) {
            console.error("Erro ao remover áreas:", error);
        }
    }

    // desfaz a ultima area adicionada
    undo(){
        if(this.history.length === 1){
            this.currentArea = JSON.parse(JSON.stringify(this.history[0].area));
            this.currentLine = JSON.parse(JSON.stringify(this.history[0].line));
            this.newCoords = JSON.parse(JSON.stringify(this.history[0].location));
            this.loadAreas();
            this.loadLines();
            this.map.getSource('points').setData({
                'type': 'FeatureCollection',
                'features': [
                    {
                        'type': 'Feature',
                        'geometry': {
                            'type': 'Point',
                            'coordinates': [this.newCoords.lng, this.newCoords.lat]
                        },
                        'properties': {
                            'id': this.id,
                            'icon': this.icontype,
                            'name': this.name
                        }
                    }
                ]
            });
            return
        }
        if(this.history[this.history.length - 1].location){
            this.map.getSource('points').setData({
                'type': 'FeatureCollection',
                'features': [
                    {
                        'type': 'Feature',
                        'geometry': {
                            'type': 'Point',
                            'coordinates': [this.history[this.history.length - 1].location.lng, this.history[this.history.length - 1].location.lat]
                        },
                        'properties': {
                            'id': this.id,
                            'icon': this.icontype,
                            'name': this.name
                        }
                    }
                ]
            });
            this.redoHistory.push({location: this.newCoords});
            this.newCoords = this.history[this.history.length - 1].location;
        }
        if(this.history[this.history.length - 1].area){
            this.redoHistory.push({area: this.currentArea});
            this.currentArea = this.history[this.history.length - 1].area;
            this.loadAreas();
        }
        if(this.history[this.history.length - 1].line){
            this.redoHistory.push({line: this.currentLine});
            this.currentLine = this.history[this.history.length - 1].line;
            this.loadLines();
        }
        this.history.pop();
    }

    redo(){
        if(this.redoHistory.length === 0){
            return;
        }
        if(this.redoHistory && this.redoHistory[this.redoHistory.length - 1] && this.redoHistory[this.redoHistory.length - 1].location){
            this.map.getSource('points').setData({
                'type': 'FeatureCollection',
                'features': [
                    {
                        'type': 'Feature',
                        'geometry': {
                            'type': 'Point',
                            'coordinates': [this.redoHistory[this.redoHistory.length - 1].location.lng, this.redoHistory[this.redoHistory.length - 1].location.lat]
                        },
                        'properties': {
                            'id': this.id,
                            'icon': this.icontype,
                            'name': this.name
                        }
                    }
                ]
            });
        }
        if(this.redoHistory && this.redoHistory[this.redoHistory.length - 1] && this.redoHistory[this.redoHistory.length - 1].area){
            this.currentArea = this.redoHistory[this.redoHistory.length - 1].area;
            this.loadAreas();
        }
        if(this.redoHistory && this.redoHistory[this.redoHistory.length - 1] && this.redoHistory[this.redoHistory.length - 1].line){
            this.currentLine = this.redoHistory[this.redoHistory.length - 1].line;
            this.loadLines();
        }
        this.redoHistory.pop();
    }

    async getAllAreas(){
        try {
            let areas = await this.equipamentRequests.getAllAreas();
            areas = areas.message.map(area => {
                return{
                    id: area.id,
                    name: area.name,
                    checked: this.areas.some(a => a.id === area.id),
                }
            })
            return areas;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
        }
    }

    // busca areas e linhas relacionadas ao equipamento
    async getAreasAndLines(id) {
        try {
            const response = await this.equipamentRequests.getLines(id);
            if(response.message.length > 0){
                response.message.forEach(line => {
                    line.line.coordinates.forEach(coord => {
                        this.currentLine.push(coord)
                    });
                    this.lineId = line.id
                })
                this.savedLines = response.message;
                this.history[0].line = JSON.parse(JSON.stringify(this.currentLine));
                this.loadLines();
            }
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
        }
        let areas = await this.getAreas(id);
        return areas;
    }

    // salva a localizações no banco de dados
    async saveLocations(equipamentId, areaName) {
        if (this.areaId){
            let currentAreas = JSON.parse(JSON.stringify(this.currentArea));
            currentAreas.push(currentAreas[0]);
            let form = {
                points: currentAreas,
            }
            try {
                const response = await this.equipamentRequests.editArea(this.areaId, form);
                toast(response.message, {
                    position: "top-center",
                    type: 'success',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    theme: config.theme,
                });
            } catch (error) {
                toast(error.message, {
                    position: "top-center",
                    type: 'error',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    theme: config.theme,
                });
                if(error.status === 401){
                    store.dispatch(LogOut());
                }
            }
        }else if (this.currentArea.length > 2) {
            try {
                let currentAreas = JSON.parse(JSON.stringify(this.currentArea));
                currentAreas.push(currentAreas[0]);
                let savedArea = {
                    "name": areaName || "Area",
                    "description": "Area para o equipamento"+ equipamentId,
                    "points": currentAreas,
                }
                const response = await this.equipamentRequests.saveArea(savedArea);
                this.areaId = response[0].id;
                await this.equipamentRequests.linkEquipamentToArea(equipamentId, response[0].id);
                toast(response.message, {
                    position: "top-center",
                    type: 'success',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    theme: config.theme,
                });
            } catch (error) {
                toast(error.message, {
                    position: "top-center",
                    type: 'error',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    theme: config.theme,
                });
                if(error.status === 401){
                    store.dispatch(LogOut());
                }
            }
        }

        if(this.currentLine.length > 1){
            if(this.lineId){
                const LineEdit = {
                    points: this.currentLine,
                }
                try {
                    const response = await this.equipamentRequests.editLine(this.lineId, LineEdit);
                    toast(response.message, {
                        position: "top-center",
                        type: 'success',
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: false,
                        progress: undefined,
                        theme: config.theme,
                    });
                } catch (error) {
                    toast(error.message, {
                        position: "top-center",
                        type: 'error',
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: false,
                        progress: undefined,
                        theme: config.theme,
                    });
                    if(error.status === 401){
                        store.dispatch(LogOut());
                    }
                }
            }else{
                let savedLine = {
                    "name": "Line"+equipamentId,
                    "equipment": equipamentId,
                    "points": this.currentLine,
                }
                try {
                    const response = await this.equipamentRequests.saveLine(savedLine);
                    toast(response.message, {
                        position: "top-center",
                        type: 'success',
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: false,
                        progress: undefined,
                        theme: config.theme,
                    });
                } catch (error) {
                    toast(error.message, {
                        position: "top-center",
                        type: 'error',
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: false,
                        progress: undefined,
                        theme: config.theme,
                    });
                    if(error.status === 401){
                        store.dispatch(LogOut());
                    }
                }
            }
        }

        if(this.newCoords){
            let form = new FormData();
            form.append('latitude', this.newCoords.lat)
            form.append('longitude', this.newCoords.lng)
            form.append('_method', 'PATCH');
            const equipament = await this.editEquipament(equipamentId, form);
            return equipament;
        }
    }

    // remover area do mapa e desvincula do equipamento
    async removeArea(equipamentId, areaId) {
        try {
            const response = await this.equipamentRequests.removeLinkEquipamentFromArea(equipamentId, areaId);
            toast(response.message, {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            this.areas = this.areas.filter(area => area.id !== areaId);
            console.log(this.areas)
            this.loadAreas();
            return true;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    // busca areas e linhas relacionadas ao equipamento
    async getAreas(id) {
        try {
            const response = await this.equipamentRequests.getAreas(id);
            this.areas = response.areas;
            this.loadAreas();
            return response.areas;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
        }
    }

    // adiciona uma nova área ao equipamento
    async addArea(equipamentId, areaId) {
        try {
            const response = await this.equipamentRequests.linkEquipamentToArea(equipamentId, areaId);
            toast(response.message, {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            this.getAreas(equipamentId)
            return true;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    // exclui todas as linhas salvas
    async cleanLines(){
        if(this.savedLines.length > 1){
            this.savedLines.forEach((line) => {
                this.equipamentRequests.DeleteLine(line.id);
            })
            this.savedLines = [];
            this.lineId = null;
        }
        if(this.currentLine.length > 0){
            this.currentLine = [];
            this.history.push({
                line: JSON.parse(JSON.stringify(this.currentLine)),
            });
            this.loadLines();
        }
    }

}